import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const FAQContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
`;

export const FAQHeader = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  background: white;
  border-bottom: 1px solid #E5E5E5;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 480px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

export const FAQBack = styled.button`
  position: absolute;
  left: 20px;
  border: none;
  background: none;
  padding: 8px;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
`;

export const FAQTitle = styled.div`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;

export const FAQSortDiv = styled.div`
  display: flex;
  z-index: 1;
  flex-direction: row;
  margin-top: 80px;
  margin-left: 15px;
`;

export const FAQSort = styled.div`
  display: flex;
  padding: 6px 11px;
  margin: 0px 5px;
  background-color: white;
  border: 1px solid #f1f1f1;
  border-radius: 17px;
  font-size: 13.5px;

  &:focus,
  &.active {
    outline: none;
    background-color: #f1f1f1;
  }
`;

export const FAQBoard = styled.div`
  display: flex;
  margin-top: 10px;
  flex-direction: column;
  overflow-y: auto;
  max-height: calc(100vh - 185px);
`;

export const FAQInquiry = styled(Link)`
  position: fixed;
  left: 50%;
  bottom: 15px;
  transform: translateX(-50%);
  width: 85%;
  max-width: 440px;
  padding: 13px;
  text-align: center;
  color: white;
  font-size: 15px;
  font-weight: bold;
  background-color: #1fbc70;
  border-radius: 15px;
  border-color: #1fbc70;
  text-decoration: none;
`;
